import {camelizeKeys, decamelizeKeys} from 'humps';

export enum GatewayCode {
    STRIPE = 'stripe',
    PAYPAL = 'paypal',
}

export enum GatewayStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export interface Gateway {
    isConnected: boolean;
    gatewayCode: GatewayCode;
    gatewayName: string;
    status: GatewayStatus;
    accountId: string;
    publishableKey: string;
    expiresAt: string;
    display?: {
        available?: boolean;
        msg?: string | null;
    };
}

export interface GatewayApiResponse {
    is_connected: boolean;
    gateway_code: GatewayCode;
    gateway_name: string;
    status: GatewayStatus;
    account_id: string;
    publishable_key: string;
    expires_at: string;
    display?: {
        available?: boolean;
        msg?: string | null;
    };
}

export const mapToGateway = (rawObject: GatewayApiResponse) => {
    return camelizeKeys(rawObject) as Gateway;
};

export const mapToRawGateway = (gateway: Gateway) => {
    return decamelizeKeys(gateway) as GatewayApiResponse;
};
